import React from 'react';
import classNames from 'classnames';

import Avatar from 'components/Avatar';

import './styles.css';

export const UserBaseDetails = ({user, white}: any) => {
  const {avatarCropped, internalAvatarCropped, fullName, initials} = user;

  return (
    <div className="UserBaseDetails">
      <Avatar
        url={internalAvatarCropped || avatarCropped}
        initials={initials}
        white
        key={avatarCropped}
      />
      <div className="info">
        <p className={classNames('name', {white})}>{fullName}</p>
      </div>
    </div>
  );
};
